export default __webpack_public_path__ + "static/media/megane-colour-6.de95af70.jpg";